/* /en/lang.js */
export default {
  // Home
  __dashboard: 'Dashboard',
  __language: 'Language',
  __languageTw: '繁體中文',
  __languageEn: 'English',
  __logout: 'Logout',
  __login: 'Login',
  __account: 'Account',
  __password: 'Password',
  __rememberMe: 'Remember me',
  __forgotPassword: 'Forgot Password?',
  __forgotPasswordDesc: "Enter your email address and we'll send a link to reset password",
  __sendResetLink: 'Send Reset Link',
  __goToSignIn: 'Go to ',
  __signIn: 'Sign in',
  __isError: 'Incorrect Password!',
  __success: 'Success',
  __loginSuccess: 'Login Successful',
  __error: 'Error',
  __otpResentSuccess: 'OTP has been resent',
  __otpResentFail: 'Failed to resend OTP',
  __networkError: 'Network error, please try again later',
  // Reset Password
  __resetPassword: 'Reset Password',
  __resetPasswordDesc: 'For security, please update your password on first login.',
  __newPassword: 'New Password',
  __confirmPassword: 'Confirm Password',
  __passwordHint: 'New password must contain both letter and numeral',
  __passUpper: 'Password must contain uppercase letters',
  __passLower: 'Password must contain lowercase letters',
  __passNumber: 'Password must contain numbers',
  __passLength: 'Password length between 12 - 20',
  __passNotMatch: '* Error: Passwords do not match',
  // Job Assignment
  __jobAssignmentList: 'Job Assignment',
  __jobAssignment: 'Job Assignment',
  __newReport: 'New Report',
  __no: 'No',
  __caseId: 'Case ID',
  __customer: 'Customer',
  __groupRemark: 'Group',
  __item: 'Item',
  __reporter: 'Reporter',
  __editor: 'Editor',
  __createTime: 'Create Time',
  __updateTime: 'Update Time',
  __date: 'Date',
  __closeDate: 'Close Date',
  __duration: 'Duration',
  __seName: 'SE',
  __assigned: 'Assigned',
  __jobStatus: 'Status',
  __itemId: 'Item ID',
  __place: 'Place',
  __issue: 'Issue',
  __remark: 'Remark',
  __remarks: 'Remarks',
  __picVideo: 'Pic/Video',
  __memberNotification: 'Member Notification',
  __feFeedbackReport: 'FE Feedback Report',
  __suggestion: 'Suggestion',
  __files: 'Files',
  __finishBtn: 'Finish',
  __selectFilesPlaceholder: 'Select files (.jpg, .mp4)',
  __selectFilesPlaceholder2: 'Select (.jpg, .mp4)',
  __chooseFile: 'Choose File',
  // History Record
  __historyRecordList: 'History Record',
  __historyRecord: 'History Record',
  __closeTime: 'Close Time',
  // Warranty & Maintenance
  __warrantyAndMaintenance: 'Warranty & Maintenance',
  __serialNumber: 'Serial Number',
  __group: 'Group',
  __contractNumber: 'Contract Number',
  __contractCurrency: 'Contract Currency',
  __startDate: 'Start Date',
  __endDate: 'End Date',
  __status: 'Status',
  __contactSales: 'Contact Sales',
  __maintenanceTab: 'Maintenance',
  __deviceTab: 'Device',
  __maintenanceExpired30: 'Maintenance Expiring in {days} Days',
  __maintenanceExpired: 'Maintenance Expired',
  __deviceExpired30: 'Device Expiring in {days} Days',
  __deviceExpired: 'Device Expired',
  __newDevice: 'New Device',
  __newMaintenance: 'New Maintenance',
  __type: 'Type',
  __rental: 'Rent',
  __sold: 'Sold',
  __contactStatus: 'Status',
  __projectId: 'Project ID',
  // Configuration
  __Configuration: 'Configuration',
  __Organization: 'Org.',
  __newOrganization: 'New Organization',
  __Staff: 'Staff',
  __newStaff: 'New Staff',
  __Customer: 'Customer',
  __customerName: 'Name',
  __newCustomer: 'New Customer',
  __Config: 'Config',
  __Authority: 'Authority',
  __SystemFunctions: 'System Functions',
  __View: 'View',
  __Edit: 'Edit',

  __groupName: 'Group Name',
  __vatNumber: 'VAT Number',
  __orgNation: 'Nation',
  __nation: 'Nation',
  __address: 'Address',
  __tel: 'Tel',
  __staffName: 'Name',
  __email: 'Email',
  __codeType: 'Code Type',
  __codeValue: 'Code Value',
  __codeText: 'Code Text',
  __order: 'Order',
  __trackStatus: 'Track Status',
  __maintenanceReason: 'Maintenance Reason',
  __managerMail: 'Manager Mail',
  __expiryReminder: 'Expiry Reminder',
  __newItem: 'New Item',
  __editItem: 'Edit Item',
  __color: 'Color',
  __description: 'Description',
  __englishText: 'English Text',
  __chineseText: 'Chinese Text',
  __managerName: 'Manager Name',
  __expirationReminderType: 'Expiration Reminder Type',
  __advanceReminderDays: 'Advance Reminder Days',
  __notificationCenter: 'Notification Center',
  __editProfile: 'Edit Profile',
  __profile: 'Profile',
  __company: 'Company',
  __division: 'Division',
  __mobile: 'Mobile',
  __oldPassword: 'Old Password',
  __cancel: 'Cancel',
  __confirm: 'Confirm',
  __pleaseInputOldPassword: 'Please input Old Password',
  __pleaseConfirmPassword: 'Please Confirm Password',
  __empId: 'ID',
  __title: 'Title',
  __phone: 'Phone',
  __contactPerson: 'Contact Person',
  __role: 'Role',
  __manager: 'Manager',
  __staffRole: 'Staff',
  __sales: 'Sales',
  __enabled: 'Enabled',
  __disabled: 'Disabled',
  __detail: 'Detail',

  // universal
  __languageSetting: 'Language Setting',
  __select: 'Select',
  __enter: 'Enter ',
  __selectFile: 'Select File',
  __downloadExcel: 'Download Excel',
  __inputError: 'Input Error',
  __inputErrorContent: 'The start date cannot be later than the end date.',
  __inputErrorContent2: 'The redemption period cannot be longer than the usage period.',
  __completeInformation: 'Complete Information',
  __content: 'Content',
  __back: 'Back',
  __collapse: 'Collapse',
  __save: 'Save',
  __new: 'Newly Added',
  __delete: 'delete',
  __deleteBtn: 'Delete',
  __settings: 'Settings',
  __keywordSearch: 'Enter Keyword',
  __categorySearch: 'Category Search',
  __edit: 'Edit',
  __total: 'Total',
  __all: 'Total',
  __total2: 'Item',
  __totalCount: 'Total {count} record | Total {count} records',
  __go: 'Go to page',
  __page: '',
  __savedSuccessfully: 'Saved Successfully',
  __savedError: 'Saved Error',
  __noticeTitle: 'Notice',
  __noticeContent: 'This notification is for viewing purposes only.\nNo email or additional notifications will be sent.',

  // ShowMsg
  __requiredTitle: 'Incomplete information',
  __requiredContent: 'Please enter all required fields.',
  __newTitle: 'Added information',
  __newContent: 'The system has added the data.',
  __revisedTitle: 'Revised data',
  __revisedContent: 'The system has modified the data.',
  __deleteTitle: 'Deleted Data',
  __deleteContent: 'The system has deleted the data.',
  __importTitle: 'Imported',
  __importContent: 'Information imported into the system.',
  __sendContent: 'Thank you for your inquiry.',
  __imageTitle: 'Incorrect Image requirements',
  __imageContent: 'Please ensure image size is less than 500KB, with resolution of W1130 x H585 pixels.',
  __imageContent2: 'Please ensure image size is less than 500KB, with resolution of W1200 x H800 pixels.',
  __imageSizeTitle: 'Image does not meet the requirements',
  __imageSize500Content: 'Please make sure the image is smaller than 500KB.',
  __ckeditorTitle: 'Word count exceeds requirements',
  __ckeditorContent: 'Word count exceeds 1500. Please check again.',
  __ckeditorContent1: 'Word count exceeds 20000. Please check again.',
  __querySuccessTitle: 'Query successful',
  __querySuccessContent: 'The system has queried the order.',
  __maintenanceAnnouncementTitle: 'Announcement Period',
  __maintenanceAnnouncementContent: 'The input was not completed during the announcement period, please confirm again. ',
  __maintenanceAnnouncementWrongTitle: 'Announcement Period Wrong',
  __maintenanceAnnouncementWrongContent: 'The start time cannot be greater than the end time. Please check again.',
  __batchBodificationTitle: 'Batch Modification',
  __batchBodificationContent: 'The system has modified the data in batches!',
  __systemHint: 'System Message',
  __pleaseSelectItem: 'Please select an item',
  __startDateGreater: 'Start date cannot be later than end date',
  __endDateLess: 'End date cannot be earlier than start date',
  __passwordNotMatch: "Passwords do not match.",
  __invalidId: 'Invalid or missing ID',
  __noPermission: 'You do not have permission to access this data',

  // ShowConfirm
  __confirmTitle2: 'Confirm Deletion',
  __confirmContent2: 'Are you sure you want to delete this record?',
  __confirmTitle10: 'Batch change',
  __confirmContent10: 'Are you sure you want to change the sending time to "Today" and the status to "Sent"?',

  // ConfirmPassword
  __deletePassword: 'Delete password',
  __deletePasswordTitle: 'Please enter the deletion password below:',
  __deletePasswordError: 'Please enter an error',
  __deletePasswordConfirm: 'Confirm Deletion',

  // ImportFile
  __import: 'Import',
  __importHint: 'Please ensure the uploaded file follows the Excel format specification. Click "Download Sample" to view the template.',
  __downloadSample: 'Download Sample',
  __confirmImport: 'Confirm Import',
  __noFileSelected: 'No file selected',
  __pleaseSelectFile: 'Please select a file first',
  __importFailed: 'Import failed',
  __selectImportFile: 'Select data to import (.xlsx)',

  __downloadPreview: 'PDF Preview',
  __downloadBtn: 'Download',
  __download: 'Download original image',
  __contractAmount: 'Contract Amount',
  __servicePlan: 'Service Plan',
  __preventiveMaintenance: 'Preventive Maintenance',
  __correctiveMaintenance: 'Corrective Maintenance',
  __inspection: 'Inspection',
  __installation: 'Installation',
  __loadTest: 'Load Test',
  __others: 'Others',
  __servicePlanRemark: 'Service Plan Remark',
  __contractServiceDescription: 'Contract Service Description',
  __sapInvoiceNumber: 'SAP Invoice Number',
  __contractDocument: 'Contract Document',
  __devices: 'Device(s)',
  __fileName: 'File Name',
  __uploadDate: 'Upload Date',
  __addAttachment: 'Add Attachment',
  __maintenance: 'Maintenance',
  __contactPhone: 'Contact Phone',
  __contactEmail: 'Contact Email',
  __device: 'Device',
  __brand: 'Brand',
  __version: 'Version',
  __itemCode: 'Item Code',
  __itemName: 'Item Name',
  __deviceCurrency: 'Device Currency',
  __deviceAmount: 'Device Amount',
  __clientAssetNumber: 'Client Asset Number',
  __deviceLocation: 'Device Location',
  __deviceDescription: 'Device Description',
  __project: 'Project',
  __projectID: 'Project ID',
  __bindMaintenanceContract: 'Bind Maintenance',
  __bindEquipment: 'Bind Device',
  __maintenanceRecord: 'Maintenance Record',
  __exportExcel: 'Export Excel',
  __importExcel: 'Import Excel',
  __importResultTitle: 'Import Result',
  __importErrors: 'Error Details',

  // S3 File Manager
  __s3Files: 'Attachment Files',
  __s3Upload: 'Upload File',
  __s3NoFiles: 'No files uploaded',
  __s3Delete: 'Delete',
  __s3Rename: 'Rename',
  __s3Preview: 'Preview / Download',
  __s3RenameDialog: 'Rename File',
  __s3NewFileName: 'New File Name',
  __s3Uploading: 'Uploading...',
  __s3DeleteConfirm: 'Are you sure you want to delete this file?',
  __s3DeleteBindConfirm: 'Are you sure you want to delete this binding?',
  __s3PreviewUrl: 'Temporary Authorization URL (Link expires in 1 hour)',
  __s3UploadSuccess: 'File uploaded successfully',
  __s3DeleteSuccess: 'File deleted successfully',
  __deleteSuccess: 'Delete successfully',
  __s3RenameSuccess: 'File renamed successfully',
  __s3UrlCopied: 'URL copied to clipboard',
  __s3NewFolder: 'New Folder',
  __s3FolderName: 'Folder Name',
  __s3FolderCreated: 'Folder created successfully',
  __s3GoBack: '.. Go Back',

  // Dashboard
  __dashboardJobAssignment: 'Job Assignment',
  __dashboardIncompleteTasks: 'Number of Incomplete Tasks',
  __dashboardNoData: 'No data available',
  __dashboardViewMore: 'View More',
  __dashboardEngineerAvgLoad: 'Engineer Average Case Load',
  __dashboardMaintenanceExpiry: 'Maintenance Contract Expiry',
  __dashboardMaintenanceExpiringDays: 'Maintenance Expiring in {days} Days',
  __dashboardMaintenanceExpired: 'Maintenance Expired',
  __dashboardDeviceWarrantyExpiry: 'Device Warranty Expiry',
  __dashboardDeviceExpiringDays: 'Device Expiring in {days} Days',
  __dashboardDeviceExpired: 'Device Expired',
  __dashboardAvg: 'Avg',

  // JobAssignmentList - Supervisor Stats Table
  __today: 'Today',
  __efficient: 'Average Days per Case',
  __urgent: 'Urgent',
  __unfinishedTask: 'Unfinished Task',
  __closed: 'Closed',
  __currentlySelected: 'Currently selected',

  // Notification Center labels
  __notifJobAssignment: 'Job Assignment',
  __notifMaintenanceExpiry: 'Maintenance Expiry',
  __notifDeviceExpiry: 'Device Expiry',

  // JobAssignment page
  __sectionReport: 'Report',
  __sectionAssign: 'Assign',
  __sectionHistory: 'History',
  __underWarranty: 'Under Warranty',
  __noFilesSelected: 'No files selected',
  __noHistoryRecords: 'No history records found',
  __noEmployeesFound: 'No employees found',
  __clickCopy: 'Click to copy',
  __selected: 'Selected',
  __none: 'None',
  __noAttachments: 'No attachments',
  __functionMenu: 'Function Menu',
  __renew: 'Renew',
  __renewSuccessMsg: 'The period has been extended on the screen. Click "Confirm" to save as a new maintenance contract.',
  __systemError: 'System Error: Please contact the administrator. (Error Code: {code})',
  __getDataError: 'System Error: Unable to retrieve data.',
  __queryFailed: 'Query Failed',
  __exportPdfError: 'PDF Export Failed. Please contact the administrator.',
  __exportFailed: 'Export Failed',
  __deleteFailed: 'Delete Failed',
  __uploadFailed: 'Upload Failed',
  __uploadFailedPartially: 'Some files failed to upload, please try again.',
  __saveFailed: 'Save Failed',
  __accountExists: 'Account already exists',
  __groupNameExists: 'Group Name already exists',
  __customerNameExists: 'Customer name already exists',
  __serialNumberExists: 'Serial Number already exists',
  __invalidEmail: 'Invalid email format',
  __duplicateTrackStatus: 'This track status already exists. Please enter another name.',
  __duplicateEnglishText: 'This English text already exists. Please enter another name.',
  __duplicateChineseText: 'This Chinese text already exists. Please enter another name.',
  __hasPendingCases: 'Active job assignments exist for this account. Deletion is not allowed.',
  __keywordSearchTooltip: 'Supported fields for keyword search:\n- No\n- Case ID\n- Customer\n- Item\n- Reporter\n- Assigned\n- Status',
  __keywordSearchMaintenanceTooltip: 'Supported fields for keyword search:\n- No\n- Serial Number\n- Customer\n- Group\n- Contract Number\n- Contract Currency\n- Status',
  __keywordSearchDeviceTooltip: 'Supported fields for keyword search:\n- No\n- Type\n- Serial Number\n- Customer\n- Group\n- Project ID\n- Project Name\n- Contract Status\n- SAP Invoice Number\n- Item Name\n- Item Code',
  __noDevicesAdded: 'No devices added',
  __noMaintenanceRecordsAdded: 'No maintenance records added',
  __copyWeb: 'Copy',
  __openWeb: 'Open',
  __copy: 'Copy Link',
  __open: 'Open in tab',
  __abbreviation: 'Abbreviation',
  __selectCustomer: 'Select Customer',
  __noCustomersFound: 'No customers found',
}